import React from "react";
import {
    getCardMedia,
    getSafeCta,
    renderSanitizedHtmlContent,
    appendQueryParamsToExternalUrl,
} from "@qlik/qlik/src/lib/util/helpers";
import Link from "@qlik/qlik/src/components/Link";
import Media from "@qlik/qlik/src/components/Media";

/**
 * ContentResourceCard component
 * @param {Object} props - The props for the component
 * @param {Object} props.card - The card data for the component
 * @param {string} props.className - The className for the component
 * @returns {JSX.Element} - Rendered component
 */
const ContentResourceCard = ({ card, className = null }) => {
    const { title, cta = [] } = card ?? {};

    const resourceMedia = getCardMedia(card);

    // Get safe CTA data
    const { internalLink, externalUrl, text: linkText } = getSafeCta(cta) ?? {};
    const externalUrlFull = externalUrl && appendQueryParamsToExternalUrl(externalUrl, getSafeCta(cta));

    return (
        // RichLink component
        <Link
            to={internalLink?.slug ?? externalUrlFull}
            className="block hover:no-underline group/resource-card lg:hover:shadow-lg rounded transition-shadow duration-300"
        >
            <div
                className={`border border-stone border-opacity-50 rounded h-full p-5 lg:p-4.75 flex flex-col ${className}`}
            >
                <div className="max-h-80 md:h-32 lg:h-45 xl:h-60 overflow-hidden">
                    {/* Check if media exists */}
                    {resourceMedia && (
                        // Media component
                        <Media
                            media={resourceMedia}
                            className="w-full h-full object-cover lg:group-hover/resource-card:scale-110 transition-transform duration-300"
                        />
                    )}
                </div>
                <p className="title-5 mt-7.75 mx-2.5 lg:mt-10 text-gray text-base lg:text-xl lg:mx-5 line-clamp-3">
                    {/* Set inner HTML */}
                    {/* eslint-disable-next-line react/no-danger */}
                    <span dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }} />
                </p>
                <div className="mt-auto mb-2.25 mx-2.5 flex flex-wrap gap-4 pt-[37px] lg:pt-[67px] lg:mx-5 lg:mb-5">
                    <span className="grey-link text-sm lg:group-hover/resource-card:text-green lg:group-hover/resource-card:after:arrow-green">
                        {/* Display link text */}
                        {linkText}
                    </span>
                </div>
            </div>
        </Link>
    );
};

export default ContentResourceCard;
